import { css } from 'lit'

export const rmaRequest = css`
  .rma-request__section {
    display: block;
    margin-bottom: var(--spacing-l, 1.5rem);
  }
`
